import React from "react";
import {
    CenteredCarImage,
    Container,
    Description,
    Link,
    SideBuyBag,
    Title,
    Wrapper,
  } from "../../../Success/success.styles";
import { Logo } from "../../components/PaymentHeader/PaymentHeader.styles";
import { useHistory } from 'react-router';
const Expired = (props: any) => {
const history = useHistory();

const goToHome = () => {
  history.push('/');
};

  return (
    <Container>
      <Logo src="images/logo.svg" />
      <Wrapper>
        <CenteredCarImage src="images/success/black-car.png" />
        <SideBuyBag src="images/success/bag-baloon.png" />
        <Title>Ops!</Title>
        <Description>
          <b>O seu boleto está vencido!</b>
          <Description>
            Parece que o prazo para pagamento <br/> do seu boleto expirou. 
            Clique no botão abaixo para realizar uma nova compra.
          </Description> 
        </Description>
        <Link
          title="Ir para vistoria"
          onClick={() => { goToHome(); }}
        >Ir para página inicial</Link>
      </Wrapper>
    </Container>
  )
}

export default Expired;